import React, {useRef, useState} from 'react'
import './ProfitableOffer.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";
import Slider from "react-slick";
import {SliderButton} from "../../../components/ui-elements/buttons/Buttons";
import FilterSlider from "../../../components/filterSlider/FilterSlider";
import SliderCard from "../../../components/cards/SliderCard/SliderCard";



function ProfitableOffer(props) {
    const {staticTexts, bestOffers, minPrices} = props
    let sliderRef = useRef(null);
    const [slideIndex, setSlideIndex] = useState(null);

    const nextSlide = () => {
        sliderRef.slickGoTo(+slideIndex + 1);
    };

    const prevSlide = () => {
        sliderRef.slickGoTo(slideIndex - 1);
    };


    // console.log('bestOffers?.length', slideIndex, bestOffers?.length);
    let disableNextButton= +slideIndex + 3 === bestOffers?.length;

    const settings = {
        dots: false,
        arrows: false,
        infinite: window.innerWidth < 700,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        ref: slider => (sliderRef = slider),
        beforeChange: (current, next)=>{ setSlideIndex(next)},
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    centerMode: window.innerWidth < 700,
                    centerPadding: '20px 0 0 0',
                }
            },
            {
                breakpoint: 350,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    };

    return <div className={'ProfitableOffer'}>
        <div className={'title-block'}>
            <h1 className={'title'}>{staticTexts?.homepage_best_offer_title}</h1>
        </div>
        <div className={'filter-block'}>
            <FilterSlider minPrices={minPrices}/>
        </div>
        <div className={`profile-btn prev-btn ${slideIndex && bestOffers?.length > 3  ? '' : 'disable'}`}
             onClick={(e) => {
                 e.preventDefault();
                 e.stopPropagation();
                 prevSlide()
             }}>
            {'<'}
        </div>
        {/*{bestOffers?.length ?*/}
        {/*    <SliderButton*/}
        {/*        className={'desktop-arrows'}*/}
        {/*        cbPrev={(e) => {*/}
        {/*            e.preventDefault();*/}
        {/*            e.stopPropagation();*/}
        {/*            sliderRef.slickPrev()*/}
        {/*        }}*/}
        {/*        cbNext={(e) => {*/}
        {/*            e.preventDefault();*/}
        {/*            e.stopPropagation();*/}
        {/*            sliderRef.slickNext()*/}
        {/*        }}*/}
        {/*    /> : ''}*/}
        <div className={'offer-slider-block'}>
            {bestOffers?.length ? <Slider{...settings}>
                {bestOffers?.map(item => {
                    return <div key={item?.id} className={'CardWrapper'}>
                        <SliderCard areas={item} staticTexts={staticTexts}/>
                    </div>
                })}
            </Slider> : ''}
        </div>
        <div className={ `profile-btn next-btn ${(disableNextButton || bestOffers?.length <= 3)  ? 'disable' : ''}`}
             onClick={(e) => {
                 e.preventDefault();
                 e.stopPropagation();
                 nextSlide()
             }}>
            >
        </div>
    </div>

}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'minPrices',
    'bestOffers',
]);

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfitableOffer);
